import { render, staticRenderFns } from "./CommissionsLogList.vue?vue&type=template&id=01b8505b&scoped=true&"
import script from "./CommissionsLogList.vue?vue&type=script&lang=js&"
export * from "./CommissionsLogList.vue?vue&type=script&lang=js&"
import style0 from "./CommissionsLogList.vue?vue&type=style&index=0&id=01b8505b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b8505b",
  null
  
)

export default component.exports